import {
  Box,
  LinearProgress,
  linearProgressClasses,
  styled,
  Tooltip,
  TooltipProps
} from '@mui/material'
import { FC, useState } from 'react'

const LinearProgressBase = styled(LinearProgress)(() => ({
  height: 10,
  borderRadius: 10,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#151615'
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 10,
    backgroundColor: '#FEBE36'
  }
}))

const Container = styled(Box)`
  position: relative;
  cursor: pointer;
`

const Point = styled(Box)`
  width: 10px;
  height: 10px;
`

const LeftPoint = styled(Point)`
  position: absolute;
  left: 0;
  top: 0;
`

const RightPoint = styled(Point)`
  position: absolute;
  right: 0;
  top: 0;
`

const StyledTooltipContent = styled(Box)`
  color: '#FFFFFF';
  background-color: #333536;
  font-size: 12px;
  border: 1px solid rgba(196, 196, 196, 0.5);
  padding: 8px 6px;
  font-weight: 700;
  border-radius: 4px;
  margin-bottom: 10px;
`

const DateTooltip = (props: TooltipProps) => (
  <Tooltip
    {...props}
    slots={{
      tooltip: StyledTooltipContent,
      ...props.slots
    }}
  />
)

export const ApeironLinearProgressBase = ({
  className,
  percent
}: BaseProps) => {
  return (
    <LinearProgressBase
      className={className}
      variant='determinate'
      value={percent}
      aria-label='progress bar'
    />
  )
}

const ApeironLinearProgress: FC<Props> = (props: Props) => {
  const { className, end, start, percent } = props

  const [isTooltipOpen, setIsTooltipOpen] = useState(false)

  const onProgressHover = () => {
    setIsTooltipOpen(true)
  }

  const onProgressBlur = () => {
    setIsTooltipOpen(false)
  }

  return (
    <Container
      className={className}
      onMouseOver={onProgressHover}
      onMouseOut={onProgressBlur}
    >
      <DateTooltip title={start} placement='top' open={isTooltipOpen}>
        <LeftPoint />
      </DateTooltip>
      <DateTooltip title={end} placement='top' open={isTooltipOpen}>
        <RightPoint />
      </DateTooltip>
      <ApeironLinearProgressBase percent={percent} />
    </Container>
  )
}

type BaseProps = {
  className?: string
  percent: number
}

type Props = {
  className?: string
  end: string
  percent: number
  start: string
}

export { DateTooltip as ProgressTooltip }

export default ApeironLinearProgress
